import { RoleEntity } from "../../../entities";
export const RoleRegistrationRequestSchema = RoleEntity.schema.pick({
    name: true,
    policies: true,
});
export const RoleInitRegistrationRequestSchema = RoleEntity.schema.pick({
    id: true,
    name: true,
    policies: true,
});
export const RoleUpdateRequestSchema = RoleEntity.schema.pick({
    name: true,
    policies: true,
});
//# sourceMappingURL=role-request.js.map